import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import {ApiService, CategoriesService, CouponUnit, Deal, DealsService, PromotionType} from '../core';
import {Category} from '../core/models/category.model';
import {PrepareDealService} from '../core/services/prepare-deal.service';
import {emptyPrefilledDeal, PrefilledDealModel} from '../core/models/prefilled-deal.model';
import {ErrorUtil} from '../core/utils/error.util';
import {ServerResponse} from '../core/models/server-response.model';
import {MenuItem} from 'primeng/api';
import {NgxDropzoneChangeEvent} from 'ngx-dropzone';
import {tap} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-submit-page',
    templateUrl: './submit.component.html'
})
export class SubmitComponent implements OnInit {
    deal: PrefilledDealModel = {} as PrefilledDealModel;
    isSubmitting = false;
    dealUrl: string;
    firstStep = true;
    secondStep = false;
    thirdStep = false;
    text: string;
    categories: Array<Category> = [];
    couponTypes: CouponUnit[];
    selectedCouponType: CouponUnit;
    dealImages = '';
    loadingDetails = false;
    errorPresent = false;
    serverError: ErrorUtil;
    steps: MenuItem[];
    activeIndex = 0;
    offersType: any[];
    selectedFile: File = null;

    constructor(
        private dealsService: DealsService,
        private route: ActivatedRoute,
        private router: Router,
        private fb: FormBuilder,
        private categoriesService: CategoriesService,
        private prepareDealService: PrepareDealService,
        private apiService: ApiService,
        private translateService: TranslateService
    ) {
        this.steps = [
            {label: translateService.instant('add_deal_progress1')},
            {label: translateService.instant('add_deal_progress2')},
            {label: translateService.instant('add_deal_progress3')}
        ];
        this.offersType = [
            {label: translateService.instant('discount'), value: PromotionType.none.valueOf()},
            {label: translateService.instant('promo_code'), value: PromotionType.promocode.valueOf()},
            {label: translateService.instant('promo_type_cart_discount'), value: PromotionType.CartDiscount.valueOf()},
            {label: translateService.instant('promo_type_amz_flash'), value: PromotionType.AmazonFlash.valueOf()},
            {label: translateService.instant('promo_type_page_discount'), value: PromotionType.AmazonCoupon.valueOf()},
            {label: translateService.instant('promo_type_amz_flash_code'), value: PromotionType.AmazonCouponAndFlash.valueOf()},
            {label: translateService.instant('cashback'), value: PromotionType.Cashback.valueOf()}
        ];
        this.couponTypes = [
            {name: '%', code: 1, class: 'p-button-dlnd'},
            {name: translateService.instant('currency_unit'), code: 2, class: 'p-button-dlnd'}
        ];
    }

    ngOnInit() {
        this.selectedCouponType = this.couponTypes[0];
        this.categoriesService.currentCategories.subscribe( data =>
            this.categories = data
        );
        this.activeIndex = 0;
    }
    updateDeal(values: Object) {
        Object.assign(this.deal, values);
    }
    prepareNewDeal(dealUrl: string) {
        this.loadingDetails = true;
        this.prepareDealService.getPreparedDeal(dealUrl).subscribe( data =>
            this.setupDeal(data),
            error => this.setupDeal(emptyPrefilledDeal(dealUrl))
        );
    }
    setupDeal(deal: PrefilledDealModel) {
        this.activeIndex = 1;
        this.loadingDetails = false;
        this.deal = deal;
        // if (deal.imageURL !== undefined) {
        //     this.dealImages = deal.imageURL;
        // }
        // // if (deal.imagesURL !== undefined && deal.imagesURL.length > 0) {
        // //     deal.imagesURL.forEach( data =>
        // //         this.dealImages.push({'url': data})
        // //     );
        // // }
        this.firstStep = false;
        this.secondStep = true;
    }

    submitDeal() {
        this.isSubmitting = true;
        // update the model
        // this.updateDeal(this.dealForm.value);

        // post the changes
        this.dealsService.save(this.deal, this.selectedCouponType.code).subscribe(
            deal => this.handleDealSubmited(deal),
            err => {
                this.handleError(err);
                this.isSubmitting = false;
            });
    }
    handleDealSubmited(resp: ServerResponse) {
        if (this.deal.imageURL === null && this.selectedFile !== null) {
            this.apiService.upload(this.selectedFile).subscribe( data =>
                this.handleImageUploaded(data, resp)
            );
        } else {
            this.handleLastStepSubmission(resp);
        }
    }
    handleImageUploaded(imageResponse: ServerResponse, dealResponse: ServerResponse) {
        if (imageResponse.ok) {
            this.dealsService.updateImage(dealResponse.linkID, imageResponse.uploadURL).subscribe( data =>
                this.handleLastStepSubmission(data)
            );
        } else {
            this.handleError(imageResponse);
        }
    }
    handleError(err: ServerResponse) {
        this.serverError = new ErrorUtil(err.error);
        this.errorPresent = true;
        this.isSubmitting = false;
    }

    onSelect($event: NgxDropzoneChangeEvent) {
        this.selectedFile = $event.addedFiles.pop();
        this.deal.imageURL = null;
    }
    handleLastStepSubmission(resp: ServerResponse) {
        if (resp.ok) {
            this.activeIndex = 2;
            this.secondStep = false;
            this.thirdStep = true;
        } else {
            this.handleError(resp);
        }
    }
    fileChange($event) {
        const files: FileList = $event.target.files;
        if (files.length > 0) {
            const file: File = files[0];
            this.apiService.upload(file).subscribe( next => next);
        }
    }
}
